import React, { FunctionComponent, SVGProps, useId } from 'react'

export const IconBlog: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  const filter1 = `${id}-filter1`
  const paint0 = `${id}-paint0`
  const paint1 = `${id}-paint1`
  return (
    <svg
      width="22"
      height="25"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M9.33333 13.6816H5.5C4.94772 13.6816 4.5 14.1294 4.5 14.6816V18.515C4.5 19.0673 4.94772 19.515 5.5 19.515H9.33333C9.88562 19.515 10.3333 19.0673 10.3333 18.515V14.6816C10.3333 14.1294 9.88562 13.6816 9.33333 13.6816Z"
          fill={`url(#${paint0})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M9.33333 13.6816H5.5C4.94772 13.6816 4.5 14.1294 4.5 14.6816V18.515C4.5 19.0673 4.94772 19.515 5.5 19.515H9.33333C9.88562 19.515 10.3333 19.0673 10.3333 18.515V14.6816C10.3333 14.1294 9.88562 13.6816 9.33333 13.6816Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter={`url(#${filter1})`}>
        <path
          d="M9.33333 4.51562H5.5C4.94772 4.51562 4.5 4.96334 4.5 5.51563V9.34896C4.5 9.90124 4.94772 10.349 5.5 10.349H9.33333C9.88562 10.349 10.3333 9.90124 10.3333 9.34896V5.51562C10.3333 4.96334 9.88562 4.51562 9.33333 4.51562Z"
          fill={`url(#${paint1})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M9.33333 4.51562H5.5C4.94772 4.51562 4.5 4.96334 4.5 5.51563V9.34896C4.5 9.90124 4.94772 10.349 5.5 10.349H9.33333C9.88562 10.349 10.3333 9.90124 10.3333 9.34896V5.51562C10.3333 4.96334 9.88562 4.51562 9.33333 4.51562Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M13.6641 5.34961H19.4974"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 9.51562H19.4974"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 14.5156H19.4974"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 18.6816H19.4974"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id={filter0}
          x="0"
          y="9.18164"
          width="14.8359"
          height="14.834"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3707_13691"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3707_13691"
            result="shape"
          />
        </filter>
        <filter
          id={filter1}
          x="0"
          y="0.015625"
          width="14.8359"
          height="14.834"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3707_13691"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3707_13691"
            result="shape"
          />
        </filter>
        <linearGradient
          id={paint0}
          x1="7.41667"
          y1="13.6816"
          x2="7.41667"
          y2="19.515"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="7.41667"
          y1="4.51562"
          x2="7.41667"
          y2="10.349"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
